module.exports = __webpack_public_path__ + "static/media/logout.5588482b.svg";